import React, {Component} from 'react';
import {
    Field,
    reduxForm
} from 'redux-form';
import {
    Grid,
    Typography
} from 'material-ui';
import {MultiSelectField} from '../../../components/fields/field_multi_select_user';
import {InputHiddenField} from '../../../components/fields/field_input_hidden';
import {BackButton} from '../../../components/buttons/BackButton';
import {SaveButton} from '../../../components/buttons/SaveButton';

class UserRolesForm extends Component {

    render() {
        const {
            userName,
            allRoles,
            allSites,
            allLanguages,
            classes,
            handleSubmit,
            pristine,
            loading
        } = this.props;

        return (
            <Grid className="userRoles" container spacing={0}>
                <Grid item xs={12}>
                    <Typography variant="title" className={classes.userEditsLead}>{userName}'s Roles, Sites and Languages</Typography>
                </Grid>
                <Grid item xs={12}>
                    <form onSubmit={handleSubmit(this.props.handleFormSubmit)} className={classes.form}>
                        <Grid container spacing={0}>
                            <Field name="id" type="hidden" component={InputHiddenField}/>
                            <Grid item xs={12}>
                                <Typography variant="subheading" className={classes.userEditsChooseText}>Choose user roles below:</Typography>
                                <Field
                                    name="roles"
                                    component={MultiSelectField}
                                    options={allRoles}
                                    placeholder="Select roles"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subheading" className={classes.userEditsChooseText}>Choose user sites below:</Typography>
                                <Field
                                    name="sites"
                                    component={MultiSelectField}
                                    options={allSites}
                                    placeholder="Select sites"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subheading" className={classes.userEditsChooseText}>Choose user languages below:</Typography>
                                <Field
                                    name="languages"
                                    component={MultiSelectField}
                                    options={allLanguages}
                                    placeholder="Select languages"
                                />
                            </Grid>
                            <Grid item xs={12} className={classes.buttonsRoles}>
                                <SaveButton
                                    type="submit"
                                    loading={loading}
                                    disabled={pristine || loading}
                                    variant="raised"
                                    color="primary"
                                    className="floatRight"
                                />
                                <BackButton
                                    link={"/users"}
                                    style={{marginRight: 15 }}
                                    variant="raised"
                                    className="floatRight"
                                />
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            </Grid>
        )
    }
}

export default reduxForm({
    form: 'UserRolesForm',
    enableReinitialize : true,
    destroyOnUnmount: false,
})(UserRolesForm);


// WEBPACK FOOTER //
// ./src/containers/users/forms/UserRolesForm.jsx